import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { H2 } from 'UIComponents/elements/headings';
import { devices } from '../styles/viewports.styles';
import { getStepTitle } from '../utils/getStepTitle';
import { Step } from '../views/Step';
import { OptionalFormattedMessage } from './OptionalFormattedMessage';
import { TitleTooltip } from './TitleTooltip';
const StyledStepTitle = styled(H2).withConfig({
  displayName: "StepTitle__StyledStepTitle",
  componentId: "we7w67-0"
})(["font-size:2rem;font-weight:700;", " ", " @media ", "{", " ", " ", "}"], props => (props.stepKey === Step.ExistingUser || props.stepKey === Step.Verification || props.stepKey === Step.CodeVerification && !props.isAssignedToVariant124) && `text-align: center;`, props => props.theme.embedded && `margin-top: 20px;
  text-align: center;
  font-size: 1.75rem;`, devices.desktop, props => props.isFramedCentredStep && 'line-height: 45px;', props => props.isFramedCentredStep && props.stepKey !== Step.Password && `padding-left: 50px;
    padding-right: 50px;`, props => props.isFramedCentredStep && props.stepKey === Step.JobRole && `padding-left: 75px;
      padding-right: 75px;`);
export const StepTitle = (_ref) => {
  let {
    hasTooltip = false,
    stepKey,
    message = null,
    className = '',
    children,
    tooltipLink,
    shouldShowDefault = true,
    isAssignedToVariant124 = false,
    isFramedCentredStep = false
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["hasTooltip", "stepKey", "message", "className", "children", "tooltipLink", "shouldShowDefault", "isAssignedToVariant124", "isFramedCentredStep"]);

  const title = useSelector(getStepTitle);
  const classNames = `${stepKey} ${className}`;
  return /*#__PURE__*/_jsxs(StyledStepTitle, Object.assign({
    className: classNames,
    isAssignedToVariant124: isAssignedToVariant124,
    isFramedCentredStep: isFramedCentredStep,
    stepKey: stepKey
  }, rest, {
    children: [shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      message: message || title
    }), hasTooltip && stepKey && tooltipLink && /*#__PURE__*/_jsx(TitleTooltip, {
      stepKey: stepKey,
      tooltipLink: tooltipLink
    }), children]
  }));
};